import { useState, useCallback } from 'react';
import { Events } from '../../../enums/Analytics';
import Analytics from '../../../tools/Analytics';

interface UseCopilotVisibilityOptions {
  defaultVisible?: boolean;
  roomUuid?: string;
}

interface UseCopilotVisibilityReturn {
  isVisible: boolean;
  openVisibilityWithDefaultMessage: (message?: string) => void;
  closeVisibility: () => void;
  toggleVisibility: () => void;
  defaultInputMessage: string;
}

const useCopilotVisibility = (
  options: UseCopilotVisibilityOptions = {}
): UseCopilotVisibilityReturn => {
  const { defaultVisible = false, roomUuid } = options;

  const [isVisible, setIsVisible] = useState(defaultVisible);
  const [defaultInputMessage, setDefaultInputMessage] = useState('');

  const closeVisibility = useCallback(() => {
    setIsVisible(false);
  }, []);

  const openVisibilityWithDefaultMessage = useCallback(
    (message?: string) => {
      setIsVisible(true);
      setDefaultInputMessage(message || '');
      Analytics.track(Events.BUYER_COPILOT_OPENED, { room_uuid: roomUuid });
    },
    [roomUuid]
  );

  const toggleVisibility = useCallback(() => {
    setIsVisible((visible) => !visible);
  }, []);

  return {
    isVisible,
    openVisibilityWithDefaultMessage,
    closeVisibility,
    toggleVisibility,
    defaultInputMessage,
  };
};

export default useCopilotVisibility;
